import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import payslip from 'url:../../../assets/payslip.png';

export default function PayslipPDF() {
  const params = useParams();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(`/payslips/${params.id}${window.location.search.toString()}`);
  };

  return (
    <div className="mobile-layout">
      <div className="mobile-content">
        <div className="image-viewer" style={{ backgroundImage: `url(${payslip})` }} />
      </div>
      <div className="mobile-footer">
        <div>
          <button type="button" className="btn">Download PDF</button>
          <button type="button" className="btn btn-outline" onClick={handleBack}>Back</button>
        </div>
      </div>
    </div>
  );
}
